import { t } from '@/features/i18n/utils';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { SummaryPage } from '@/features/summary/components/summary-page';
import z from 'zod';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/summary',
)({
  staticData: { chatSurface: 'summary' },
  component: RouteComponent,
  validateSearch: z.object({
    targetStatementId: z.string().optional(),
    commentEntityId: z.string().optional(),
    commentId: z.string().optional(),
  }),
});

function RouteComponent() {
  return (
    <>
      <Header>
        <HeaderBackButton />
        <WorkspaceBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Summary', nb: 'Sammendrag' })}</BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <SummaryPage />
    </>
  );
}
